module.exports = __webpack_public_path__ + "static/media/heart.3da0b1f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/heart.svg
// module id = 508
// module chunks = 0